// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e6f81d8","472":"5ae89fd0","828":"a1fd4a9f","873":"e7cf453f","982":"258afc7d"}[chunkId] + ".chunk.js";
};